import { useContext } from 'react';
import { Snackbar, Alert, IconButton } from '@mui/material';
import Context from '../../context';
import CloseIcon from '@mui/icons-material/Close';

const ErrorMessage = (): JSX.Element => {
  const { showError, message, setShowError } = useContext(Context);
  const handleClose = () => setShowError(false);
  return showError ? (
      <Snackbar
        data-testid="errorMessage"
        open={true}
        autoHideDuration={4000}
        anchorOrigin={{vertical:'top', horizontal:'center'}}
        onClose={handleClose}>
        <Alert  severity="error" sx={{ width: '100%', position: 'relative' }}
          action={
            <IconButton size="small" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {message}
        </Alert>
      </Snackbar>
  ) : <></>;
}

export default ErrorMessage;